export default {
    PAGE_VIEW_TRIGGER: 'Page View',
    DOMAIN_BASED_TIMED_TRIGGER: 'Domain Based Timed Trigger',
    DOM_CONTENT_LOADED_TRIGGER: 'DOM Content Loaded',
    ELEMENT_CLICK_TRIGGER: 'Click',
    OBSERVER_TRIGGER: 'Observe',
};
